module.exports = __webpack_public_path__ + "img/grayDam.cfad6dc0.svg";